<template>
  <v-container>
    <v-card>
      <v-card-title v-if="!loading">
        <v-icon left>mdi-file-document</v-icon>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn
          v-if="dataDocument && dataDocument.type === 0 && !loading"
          color="primary"
          small
          @click="printDocument"
        >
          <v-icon left>mdi-printer</v-icon>
          Imprimir
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <div v-if="loading" class="text-center my-5">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-3 grey--text">Carregando documento, aguarde...</p>
        </div>

        <div v-show="!loading">
          <!-- Exibição de HTML -->
          <div
            v-if="dataDocument && dataDocument.type === 0"
            id="print-area"
            class="document-viewer"
          >
            <div class="document-header">
              <v-icon color="primary" size="30">mdi-file-document-outline</v-icon>
              <h2>{{ dataDocument.titulo }}</h2>
            </div>
            <div class="document-body">
              <div class="document-html" v-html="dataDocument.texto"></div>
            </div>
          </div>

          <!-- Exibição de PDF/DOCX -->
          <div v-else-if="dataDocument && (dataDocument.type === 1 || dataDocument.type === 2)">
            <iframe
              ref="viewer"
              :src="url"
              width="100%"
              height="700px"
              frameborder="0"
              @load="onIframeLoad"
            ></iframe>
          </div>

          <div v-else class="text-center grey--text my-4">
            Nenhum documento disponível.
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="this.hash && this.showActions">
        <v-row
          class="d-flex justify-end"
          align="center"
        >
          <v-col
            cols="12"
            sm="3"
            md="2"
            class="mb-0 mb-sm-0 pr-sm-2"
          >
            <v-btn
              block
              color="error"
              @click="optionSelected(false)"
              :disabled="loading || loadingButton"
            >
              Reprovar
            </v-btn>
          </v-col>

          <v-col
            cols="12"
            sm="3"
            md="2"
            class="pl-sm-2"
          >
            <v-btn
              block
              color="primary"
              @click="optionSelected(true)"
              :disabled="loading || loadingButton"
            >
              Aprovar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    index: {
      type: Number,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    hash: {
      type: String,
      default: null,
      required: false
    },
    download: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  data() {
    return {
      title: 'Documento para Aprovação',
      loading: true,
      loadingButton: false,
      showActions: false,
      dataDocument: {},
      url: "",
    };
  },
  async mounted() {
    try {
      if (this.hash) {
        await this.loadDocumentGerarTermoByHash({ hash: this.hash, download: this.download ? true : '' });
      } else {
        const params = {
          index: this.index,
          solicitation_id: this.id,
        };
        await this.loadDocumentGerarTermo(params);
      }

      this.dataDocument = this.gerar_termo;

      if (this.dataDocument.type === 0) {
        this.url = "";
        this.loading = false;
        this.showActions = true;
      } else {
        this.url = this.dataDocument.texto;
      }

      if (this.download) {
        this.title = 'Visualização de Documento'
        this.showActions = false;
      }
    } catch (error) {
      this.dataDocument = null;
      await this.$swal("Oops..", error.message, "error");
      this.loading = false;
      this.showActions = false;
    }
  },
  computed: {
    ...mapState("solicitation", ["gerar_termo"]),
  },
  methods: {
    ...mapActions("solicitation", ["loadDocumentGerarTermo", "loadDocumentGerarTermoByHash","saveApproveDocument"]),
    onIframeLoad() {
      this.loading = false;
      if (!this.download) {
        this.showActions = true;
      }
    },
    async optionSelected(value) {
      try {
        this.loadingButton = true;
        const response = await this.saveApproveDocument({
          approve: value,
          texto: this.dataDocument.texto,
          type: this.dataDocument.type,
          hash: this.hash
        });
        this.showActions = false;
        this.loadingButton = false;
        await this.$swal(response.message,'', "success");
      } catch (error) {
        await this.$swal("Oops..", error.message, "error");
        this.loadingButton = false;
      }
    },
    printDocument() {
      const printContents = document.getElementById("print-area").innerHTML;
      const printWindow = window.open("", "", "height=900,width=800");
      printWindow.document.write(`
        <html>
          <head>
            <title>${this.dataDocument.titulo}</title>
            <style>
              @page { size: A4; margin: 25mm; }
              body {
                font-family: "Times New Roman", serif;
                line-height: 1.8;
                color: #000;
                background: #fff;
              }
              h2 { text-align: center; color: #1a237e; }
              .document-body { text-align: justify; }
              table {
                width: 100% !important;
                border-collapse: collapse;
                table-layout: auto;
                word-break: break-word;
                margin-bottom: 1rem;
              }
              td, th {
                border: 1px solid #ccc;
                padding: 6px 10px;
                vertical-align: top;
                word-break: break-word;
                white-space: normal;
                font-size: 12px;
              }
            </style>
          </head>
          <body>${printContents}</body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 400);
    },
  },
};
</script>

<style scoped>
iframe {
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
}

.document-viewer {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow:
    0 0 2px rgba(0, 0, 0, 0.1),
    0 15px 25px rgba(0, 0, 0, 0.08);
  padding: 60px 70px;
  max-width: 1000px;
  margin: 40px auto;
  font-family: "Times New Roman", serif;
  font-size: 1.05rem;
  color: #333;
  position: relative;
  background-image: radial-gradient(
    circle at 1px 1px,
    rgba(0, 0, 0, 0.02) 1px,
    transparent 0
  );
  background-size: 20px 20px;
}

.document-viewer::before {
  content: "";
  position: absolute;
  top: 15px;
  bottom: 15px;
  left: 15px;
  right: 15px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  pointer-events: none;
}

.document-header {
  text-align: center;
  margin-bottom: 40px;
}

.document-header h2 {
  font-size: 1.8rem;
  margin-top: 10px;
  color: #1a237e;
  font-weight: 700;
  text-transform: capitalize;
}

.document-body {
  overflow-x: auto;
  text-align: justify;
}

.document-body table {
  width: 100% !important;
  max-width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
  table-layout: auto;
  word-wrap: break-word;
}

.document-body td,
.document-body th {
  word-break: break-word;
  white-space: normal;
  padding: 6px 10px;
  border: 1px solid #ddd;
  vertical-align: top;
}

.document-body ::v-deep table[width],
.document-body ::v-deep td[width],
.document-body ::v-deep th[width] {
  width: auto !important;
}

@media print {
  .document-body table {
    page-break-inside: avoid;
  }
  .document-body td,
  .document-body th {
    font-size: 12px;
  }
}
</style>
